module.exports = __webpack_public_path__ + "img/wash-sq.d4528dc9.svg";